const firebaseConfig = {
    apiKey: "AIzaSyBWeF9kUIObNSYtN6qinx5D7gnYznstSYI",
    authDomain: "crypto-hunter-87ccc.firebaseapp.com",
    projectId: "crypto-hunter-87ccc",
    storageBucket: "crypto-hunter-87ccc.appspot.com",
    messagingSenderId: "917539630334",
    appId: "1:917539630334:web:d7a1ca170e180efa1c49af"
  };

export default firebaseConfig  